<template>
  <el-dialog append-to-body width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
    <div class="modal-body">
      <div class="reset-form">
        <div class="login-msg">
          <div class="phone-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_phone_icon.png" alt="">
            </div>
            <input type="text" name="phone" placeholder="请输入手机号" id="phone" readonly v-model="form.phone">
          </div>
          <div class="code-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_msg_icon.png" alt="">
            </div>
            <input type="text" name="code" placeholder="请输入短信验证码" id="code" v-model="form.code">
            <div class="send-code-btn flex-cc" @click="sendCode">
              {{ text }}
            </div>
          </div>
          <div class="new-pwd-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_pwd_icon1.png" alt="">
            </div>
            <input type="password" name="password" placeholder="请输入新密码" id="newPwd" v-model="form.password">
          </div>
          <div class="new-pwd-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_pwd_icon.png" alt="">
            </div>
            <input type="password" name="repassword" placeholder="请确认新密码" id="newPwd" v-model="form.repassword">
          </div>
          <div class="btn-list">
            <el-button class="submit flex-cc" :loading="loading" @click="handleSubmit">确认</el-button>
            <el-button class="cancel flex-cc" @click="handleClose">取消</el-button>
          </div>
        </div>
      </div>
      <!-- 滑动验证码 -->
      <Verify ref="verify" @success="captchaSuccess" mode="pop" :captchaType="form.captchaType"
        :imgSize="{ width: '330px', height: '155px' }"></Verify>
    </div>
  </el-dialog>
</template>

<script>
import { sendCode } from "@/api/common";
import { getInfo, setPayPassword } from "@/api/user";
import waves from '@/directive/waves' // 水波纹指令
//引入组件
import Verify from "@/components/verifition/Verify";
export default {
  name: 'ResetPayPassword',
  components: {
    Verify,
  },
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: '重置支付密码'
    },
  },
  data() {
    return {
      loading: false,
      form: {
        phone: '',
        code: '',
        password: '',
        repassword: '',
        captchaType: "blockPuzzle",
        captchaVerification: "",
      },
      disabled: false,
      countdown: 60,
      text: "发送验证码",
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.getInfo()
      }
    }
  },
  methods: {
    getInfo() {
      getInfo(this.form).then(res => {
        this.loading = false;
        this.form.phone = res.data.phone
      }).catch((err) => {

      });
    },
    sendCode() {
      const that = this
      const _form = that.form;
      if (that.disabled) return
      console.log(_form)
      if (!_form.captchaVerification) {
        this.$refs.verify.show()
        return;
      }
      that.disabled = true
      sendCode(that.form).then((res) => {
        that.timer = setInterval(() => {
          that.countdown--
          this.text = "重新发送(" + that.countdown + "s)"
          if (that.countdown == 0) {
            that.disabled = false
            that.text = '发送验证码'
            that.countdown = 60
            clearInterval(that.timer)
          }
        }, 1000)

        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '短信发送成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    captchaSuccess(params) {
      console.log(params);
      this.form = {
        ...this.form,
        ...params,
      }
      this.sendCode()
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    },
    // 提交订单
    handleSubmit() {
      const _form = this.form;
      if (!_form.password) {
        this.$message({
          type: 'error',
          message: '请输入密码'
        });
        return;
      }
      if (_form.password != _form.repassword) {
        this.$message({
          type: 'error',
          message: '密码和确认密码不一致'
        });
        return;
      }
      if (!_form.code) {
        this.$message({
          type: 'error',
          message: '请输入验证码'
        });
        return;
      }
      if (!_form.captchaVerification) {
        this.$refs.verify.show()
        return;
      }
      this.loading = true;
      setPayPassword(_form)
        .then((res) => {
          this.loading = false;
          // 弹出操作提示
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.handleClose();
        })
        .catch(() => {
          this.loading = false;
        });

    },
    // 关闭窗口
    handleClose() {
      // 更新visible参数
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-body {
  .reset-form {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 10px;

    .login-msg {
      width: 345px;
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      margin-bottom: 35px;

      .username-inp,
      .pwd-inp,
      .phone-inp,
      .code-inp,
      .new-pwd-inp {
        display: grid;
        grid-template-columns: 63px auto;
        align-items: center;
        column-gap: 15px;
        width: 345px;
        height: 50px;
        border-radius: 4px;
        box-sizing: border-box;
        border: 0.6px solid #CCD7DB;

        &>.icon {
          width: 62px;
          height: 50px;
          border-right: 0.6px solid #CCD7DB;

          &>img {
            width: 25px;
            height: 25px;
          }
        }

        &>#username,
        #pwd,
        #code,
        #phone,
        #newPwd {
          width: calc(100% - 15px);
          border: none;
          outline: none;
          background-color: transparent;
        }

        &>.pwd-eye {
          width: 25px;
          height: 50px;
          cursor: pointer;

          &>img {
            width: 25px;
            height: 25px;
          }
        }
      }

      .btn-list {
        width: 345px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .submit {
          width: 150px;
          height: 40px;
          background: #00B4E8;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 300;
          color: #FFFFFF;
          cursor: pointer;
        }

        .cancel {
          width: 150px;
          height: 40px;
          border-radius: 20px;
          border: 1px solid #00B4E8;
          font-size: 14px;
          font-weight: 300;
          color: #00B4E8;
          cursor: pointer;
        }
      }

      .pwd-inp {
        padding-right: 19px;
        grid-template-columns: 63px auto 25px;

        #pwd {
          width: 100% !important;
        }
      }

      .code-inp {
        grid-template-columns: 63px auto 121px;

        .send-code-btn {
          height: 50px;
          font-size: 16px;
          font-weight: 400;
          color: #6F7F84;
          background: #CCD7DB;
          border-radius: 0px 4px 4px 0px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
